<div class="device-card" [ngClass]="{ 'without-header': !checkIfViewInfo(InfoDeviceEnum.icon)}">

  <app-card-header
    [showHeader]="checkIfViewInfo(InfoDeviceEnum.icon)"
    [headerClass]="'wide'"
    [title]="getHeaderTitle()!"
    [titleClass]="'wide'"
    [menuBodyClass]="'wide device-card'"
    >
    <div slot="menu-body" class="header-menu-slot">
      <div class="type">
        <app-device-type [device]="device"></app-device-type>
      </div>
      <div class="info">
        <app-online-device [device]="device"></app-online-device>
        <app-device-action
          [device]="device"
          [kcUser]="kcUser"
          (update)="loadDataSource()"
        ></app-device-action>
      </div>
    </div>
  </app-card-header>

  <div class="body">
    @if (!checkIfViewInfo(InfoDeviceEnum.icon)) {
      <div class="device-menu">
        <app-device-type [device]="device"></app-device-type>
        <app-online-device [device]="device"></app-online-device>
        <app-device-action
          [device]="device"
          [kcUser]="kcUser"
          (update)="loadDataSource()"
        ></app-device-action>
      </div>
    }
    <ul>
      @if (checkIfViewInfo(InfoDeviceEnum.icon)) {
        <li class="img-child">
          <img class="device-img" [src]="getImage()" alt="Lainox">
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.name) && !checkIfViewInfo(InfoDeviceEnum.icon)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.NAME' | translate }}</label>
          <span>{{ device.name || '--' }}</span>
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.hardware)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.HARDWARE_ID' | translate }}</label>
          <span>{{ device.hardwareId || '--' }}</span>
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.serial)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.SERIAL_NUMBER' | translate }}</label>
          <span>{{ device.serial || '--' }}</span>
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.firmware)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.FIRMWARE' | translate }}</label>
          <span>{{ device.firmware || '--' }}</span>
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.model)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.MODEL' | translate }}</label>
          <span>{{ getDeviceModel() || '--' }}</span>
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.sync)) {
        <li>
          <label>{{ 'DEVICES.DEVICE_CARD.SINC' | translate }}</label>
          @if (device.lastSync) {
            <span>{{
              device.lastSync | fromUTCToLocale | date: 'medium':timezone:lang
            }}</span>
          }
          @if (!device.lastSync) {
            <span>--</span>
          }
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.date)) {
        <li>
          <label>
            {{ 'DEVICES.DEVICE_CARD.REGISTRATION_DATE' | translate }}
          </label>
          @if (device.currentOwnerFirstAssociation) {
            <span>
              {{
              device.currentOwnerFirstAssociation
              | fromUTCToLocale
              | date: 'medium':timezone:lang
              }}
            </span>
          }
          @if (!device.currentOwnerFirstAssociation) {
            <span> -- </span>
          }
        </li>
      }
      @if (checkIfViewInfo(InfoDeviceEnum.display)) {
        <li>
          <label>{{ 'MY_DISPLAY.DISPLAY' | translate }}</label>
          <ng-container>
            <ul class="display-list">
              @for (display of device.displays; track display) {
                <li>
                  <span>{{ getDisplayName(display) }}</span>
                </li>
              }
            </ul>
          </ng-container>
        </li>
      }
    </ul>
  </div>
</div>
